import * as t from "io-ts";
import { RegionCodec } from "./region";

const AuthResultRequiredValidator = t.type({
  authToken: t.string,
  type: t.string,
  companyId: t.string,
  companyType: t.string,
  region: RegionCodec
});

const AuthResultOptionalValidator = t.partial({
  accessToken: t.string,
  tokenType: t.string
});

const AuthResultValidator = t.intersection([
  AuthResultRequiredValidator,
  AuthResultOptionalValidator
]);

export const LegacyPersonAccessTokenType = "OTSLegacyPersonAccessToken";

export type AuthResult = t.TypeOf<typeof AuthResultValidator>;

export const getLegacyAuthHeader = (authResult: AuthResult): string => {
  return authResult.accessToken || authResult.authToken;
}

export type AuthRequest = {
  username: string
  password: string
}
